// extracted by mini-css-extract-plugin
export default {"struturaFormInputs":"inputs_struturaFormInputs__yLKLw","titulo":"inputs_titulo__i2qSL"};